import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
import AresUpdatesList from "./AresUpdatesList";
import AresUpdatesEdit from "./AresUpdatesEdit";
function AresUpdates() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return React.createElement(AresUpdatesList, null); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(AresUpdatesEdit, null))); } })));
}
export default AresUpdates;
